import { EmptyView, useTheme } from "capsule"
import React, { useMemo } from "react"
import { ActivityIndicator, StyleSheet } from "react-native"

const LoadingScreen = () => {
  const {
    colors: {
      primary,
      black: { mediumEmphasis: black },
    },
  } = useTheme()

  const s = useMemo(
    () => ({
      empty: [
        styles.empty,
        {
          backgroundColor: primary,
        },
      ],
    }),
    [primary],
  )

  return (
    <EmptyView style={s.empty} viewStyle={s.empty}>
      <ActivityIndicator size="large" color={black} />
    </EmptyView>
  )
}

const styles = StyleSheet.create({
  empty: {
    flex: 1,
  },
})

export default LoadingScreen
